export const lockUpTooltipTitle = 'Lock-Up*';
